import { z } from "zod";

export const suggestionSchema = z.object({
  category: z.enum(["improvement", "new_feature"], { error: (issue) => (issue.input === undefined ? "Veuillez choisir une catégorie." : undefined) }),
  subcategory: z.string().min(1, "Veuillez choisir une sous-catégorie."),
  message: z
    .string()
    .min(10, "Le message doit contenir au moins 10 caractères.")
    .max(2000, "Le message ne peut pas dépasser 2000 caractères."),
  attachment_signed_id: z.string().optional(),
});

export type SuggestionFormValues = z.infer<typeof suggestionSchema>;
